import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'react-apollo';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import cx from 'classnames';

import { isRTL } from '../../helpers/formatLocale';

import s from './Landing.css';
import cs from '../../components/commonStyle.css';

import Hero from '../../components/LandingPage/Hero';
import FeaturedCars from '../../components/LandingPage/FeaturedCars';
import About from '../../components/LandingPage/About';
import StickySteps from '../../components/LandingPage/StickySteps';
import Comparison from '../../components/LandingPage/Comparison';
import Contact from '../../components/LandingPage/Contact';
import Faq from '../../components/LandingPage/Faq';
import AppDownload from '../../components/LandingPage/AppDownload';
import Footer from '../../components/LandingFooter';

class Landing extends React.Component {
  static propTypes = {
    locale: PropTypes.string.isRequired,
  };

  render() {
    const { locale } = this.props;
    const isRtlLocale = isRTL(locale);

    return (
      <div
        className={cx('landingPage', s.root, s.landingRoot)}
        dir={isRtlLocale ? 'rtl' : 'ltr'}
      >
        <Hero />
        <FeaturedCars />
        <About />
        <StickySteps />
        <Comparison />
        <Contact />
        <Faq />
        <AppDownload />
        <Footer />
      </div>
    );
  }
}

const mapState = (state) => ({
  locale: state.intl.locale,
});

export default compose(
  withStyles(s, cs),
  connect(mapState),
)(Landing);
